module.exports = __webpack_public_path__ + "static/media/cognizant-logo.92ca3ff7.svg";